import * as Yup from 'yup'

import { IMPRESSIONS } from '../../Multiplatform/UploadAdCreative/fields'
import { getImpressionsValidation } from '../../Multiplatform/UploadAdCreative/ImpressionsBudgetSection/validation'

export const getImpressionsValidationsSchema = (remainingImpressions, initialImpressions, calculatedImpressions) => {
  return Yup.object({
    [IMPRESSIONS]: getImpressionsValidation({
      remainingImpressions,
      initialImpressions,
      calculatedImpressions
    })
  })
}
